import {
  GetArticleQuery_query_article_Article_events_ArticleEvent,
  GetArticleQuery_query_article_Article_guides_ArticleGuide,
  TagType,
} from '../../../__generated__/queries-web';
import { Default } from '../../../components/Tags/TagItems/Default';
import { Events } from '../../../components/Tags/TagItems/Events';
import { Guides } from '../../../components/Tags/TagItems/Guides';
import { TagProgramTv } from '../../../components/Tags/TagItems/ProgramTv';
import { getBrandOptions } from '../../../utils/brands';
import { ArticleState } from '../reducer';

interface GetTagsConfiguration extends Pick<ArticleState, 'tags' | 'brandKey'> {
  events?: GetArticleQuery_query_article_Article_events_ArticleEvent[];
  guides?: GetArticleQuery_query_article_Article_guides_ArticleGuide[];
}

export const getTagsConfiguration = ({
  events,
  tags,
  guides,
  brandKey,
}: GetTagsConfiguration) => {
  const eventsTags = events?.map((articleEvent) => {
    return { ...articleEvent.category, type: 'Event' };
  });
  const otherTags = tags.map((articleTag) => articleTag.tag);
  const programTvTags = otherTags.filter(
    (tag) =>
      tag.type === TagType.TvProgram || tag.type === TagType.TvCollection,
  );
  const guidesTag = guides?.map(
    (articleGuide) => articleGuide.category || articleGuide,
  );

  return [
    {
      component: Default,
      id: 'Default',
      props: {
        field: 'tags',
        isAllowedToCreateTag: true,
        tags: otherTags,
      },
    },
    ...(!getBrandOptions(brandKey).isCerise && eventsTags
      ? [
          {
            component: Events,
            id: 'Events',
            props: { field: 'events', tags: eventsTags },
          },
        ]
      : []),
    ...(guidesTag
      ? [
          {
            component: Guides,
            id: 'Guides',
            props: { field: 'guides', tags: guidesTag },
          },
        ]
      : []),
    ...(getBrandOptions(brandKey).mediaProgramsAllowed
      ? [
          {
            component: TagProgramTv,
            id: 'TagProgramTv',
            props: { field: 'tags', tags: programTvTags },
          },
        ]
      : []),
  ];
};
